import Request from "../../utils/Request";
import {AxiosResponse} from "axios";

/**
 * @param code
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
const DenyRequest = (code:string = ""): Promise<AxiosResponse<any>> => Request.post(`/advisors/deny/${code}`);

export default DenyRequest;